module.exports = __webpack_public_path__ + "static/ishimizuImg-5b784492d82b52ca8ed18dd5e1cf4564.jpg";